import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=71f261b0&lang=scss&scoped=true"

import exportComponent from "/Users/qiuxiaofeng/Desktop/交接/assistant_eclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f261b0"]])

export default __exports__